import React, { useEffect, useState } from 'react'
import { AppBodyVM } from '../../Structure/ViewModels/AppBodyVM'
import { Container } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretLeft, faCaretRight } from '@fortawesome/free-solid-svg-icons'
import { SideBarVM } from '../../Structure/ViewModels/SideBarVM'
import { Globals } from '../../Structure/Globals/GlobalObs'

export const appBody:AppBodyVM = new AppBodyVM()

const AppBody = () => {
    const [vm,setVm] = useState<{viewModel:AppBodyVM}>({viewModel:appBody})
    const [sideBar,setSideBar] = useState<{viewModel:SideBarVM}>({viewModel:Globals.sideBar})
    useEffect(()=>{
      vm.viewModel.subscribeUpdate(setVm)
      sideBar.viewModel.subscribeUpdate(setSideBar)
    },[])
    const control = vm.viewModel

  return (
    <div className='app-body'>
      <div className={`appBody-trigger d-md-none d-block ${sideBar.viewModel.Collapsed?'':'appBody-trigger-flip shadow'}`} style={{zIndex:'1500px'}}  onClick={()=>sideBar.viewModel.Collapsed= !sideBar.viewModel.Collapsed} >
        <FontAwesomeIcon icon={faCaretLeft} />
      </div>
      <Container className='h-100'>
        <div className='d-flex p-lg-3 py-3 h-100'>
          {control.Element}
        </div>
      </Container>
  </div>
  )
}

export default AppBody
